import { find } from 'ramda'
import { createSchemaBasedConstructor } from './create-typed-constructor'

const Structure = createSchemaBasedConstructor('Structure')

/*
 * Take a list of structures for a venue and return the default one
 * @sig getDefaultStructureForVenue :: [Structure] -> Structure
 */
Structure.getDefaultStructureForVenue = structures => {
    const findDefaultStructure = s => s.isDefaultForVenue

    return find(findDefaultStructure, structures)
}

export default Structure
